import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import User from "../../../models/user";
import userService from "../../../services/userService";
import SubscriptionContextModel from "../../../contexts/subscriptionContextModel";
import SubscriptionContext from "../../../contexts/subscriptionContext";
import SearchBar from "../layout/SearchBar";

const Users: React.FC = () => {
  const navigate = useNavigate();

  const { subscription } =
    useContext<SubscriptionContextModel>(SubscriptionContext);

  const [users, setUsers] = useState<User[]>([]);
  const [allUsers, setAllUsers] = useState<User[]>([]);
  const [userSearch, setUserSearch] = useState<string>("");

  useEffect(() => {
    const init = async () => {
      try {
        const { data: users } = await userService.getUsers(
          subscription.idSubscription,
        );
        setUsers(users);
        setAllUsers(users);
      } catch (error) {
        // TODO: show error with toastr
      }
    };

    init();
  }, [subscription]);

  const onSearchChange = (event: any) => {
    setUserSearch(event.target.value);
    const searchToken = event.target.value.toLowerCase();
    const newUsers = allUsers.filter(
      (a) =>
        a.firstName.toLowerCase().includes(searchToken) ||
        a.lastName.toLowerCase().includes(searchToken) ||
        a.email.toLowerCase().includes(searchToken) ||
        a.userGroups.filter((ug) =>
          ug.userGroupName.toLocaleLowerCase().includes(searchToken),
        ).length > 0,
    );
    setUsers(newUsers);
  };

  const onCreateUserClick = () => {
    navigate("/work/users/new");
  };

  const onEditClick = (user: User) => {
    navigate(`/work/users/${user.idUser}`);
  };

  const getUserGroups = (user: User) => {
    return user.userGroups.map((ug) => ug.userGroupName).join(", ");
  };

  return (
    <div>
      {/* <div className="d-flex justify-content-between mb-2">
        <div className="d-flex align-items-center">
          <form className="search-form">
            <i className="bi bi-search search-icon"></i>
            <input
              type="search"
              name="q"
              placeholder="Search users..."
              autoComplete="off"
              value={userSearch}
              onChange={onSearchChange}
            />
          </form>
        </div>

        <div className="d-flex flex-column align-items-end">
          <button
            className="btn btn-primary"
            onClick={() => onCreateUserClick()}
          >
            Create User
          </button>
          <div>{`${users.length} users`}</div>
        </div>
      </div> */}

      <SearchBar
        placeHolderText="Search users..."
        searchValue={userSearch}
        onSearchChange={onSearchChange}
        hasCreate={true}
        createTitle="Create User"
        onCreate={() => onCreateUserClick()}
        count={users.length}
        countType="users"
        isEmbedded={true}
      />

      <div className="table-responsive">
        <table className="table table-hover table-responsive horizontal-center-td">
          <thead>
            <tr>
              <th scope="col">First Name</th>
              <th scope="col">Last Name</th>
              <th scope="col">Email</th>
              <th scope="col">Phone</th>
              <th scope="col">User Groups</th>
              <th style={{ width: "50px" }} />
            </tr>
          </thead>
          <tbody>
            {users.map((user: User) => (
              <tr key={user.idUser.toString()}>
                <td>{user.firstName}</td>
                <td>{user.lastName}</td>
                <td>{user.email}</td>
                <td>{user.phone}</td>
                <td>{getUserGroups(user)}</td>
                <td>
                  <i
                    className="ri-pencil-fill"
                    style={{ fontSize: "20px", cursor: "pointer" }}
                    onClick={() => onEditClick(user)}
                  ></i>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Users;
